import React, { useRef } from 'react';

import { Currency, ArrRight } from '@/icons/index';

import Button from '../Button/Button';
import CellData from './CellData';

import styles from './styles.module.scss';

const BusinessWifiInternetCard = ({ handleConnect = () => null, data }) => {
  const tariffItem = useRef();
  return (
    <div
      className={styles.tariff}
      ref={tariffItem}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {data?.name && data?.show_tariff_names && (
        <div className={styles['tariff-head']}>
          <div className={styles['tariff-head__content']}>
            {data?.name}
            {/* {label && <div className={styles.label}>{label}</div>} */}
          </div>
        </div>
      )}
      <div className={styles.tariff__content}>
        <div className={styles.inner}>
          {!!data.sections?.length &&
            data.sections.map((item, key) => (
              <CellData data={item} key={key} />
            ))}
          {!!data?.additions.length && (
            <div className={styles.additions}>
              {data.additions.map((addition) => (
                <div className={styles.adds} key={''}>
                  {addition}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className={styles.bottom}>
          <div className={styles.bottom__content}>
            <div className={styles['price-box']}>
              {data?.corporate_customers_price &&
                data?.individual_customers_price && (
                  <>
                    {!data.show_individual_prices && (
                      <div className={styles['price-box__content']}>
                        <div className={styles.title}>
                          {data?.individual_customers_price_title}
                        </div>
                        <div className={styles.all}>
                          <span className={styles.price}>
                            {data?.individual_customers_price}
                          </span>
                          <span className={styles.currency}>
                            <span className='currency'>
                              <Currency />
                            </span>
                            {data?.price_text}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className={styles['price-box__content']}>
                      <div className={styles.title}>
                        {data?.corporate_customers_price_title}
                      </div>
                      <div className={styles.all}>
                        <span className={styles.price}>
                          {data?.corporate_customers_price}
                        </span>
                        <span className={styles.currency}>
                          <span className='currency'>
                            <Currency />
                          </span>
                          {data?.price_text}
                        </span>
                      </div>
                    </div>
                  </>
                )}
            </div>
          </div>
          <Button className={styles.button} onClick={(id) => handleConnect(id)}>
            {data?.button_text}
            <ArrRight width={24} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BusinessWifiInternetCard;
